// vendor
import { set } from "@vue/composition-api";
// project
import { Graph, GraphNode } from "@/psychlab/types/graph";
import { Gallery } from "@/psychlab/types/gallery";
import { Scene } from "@/psychlab/types/scene";
import { Form } from "@/psychlab/types/form";
import { AssetPointer } from "@/psychlab/types/assets";
import * as AssetAPI from "@/services/api/assets";
// local
import { getReferencedNodeAssets } from "./getReferencedAssets";


type FormNode = GraphNode<{
	asset?:AssetPointer<Form>
}>;

type GalleryNode = GraphNode<{
	asset?:AssetPointer<Gallery>
}>;

type SceneNode = GraphNode<Scene>;


type CognitiveTestNode = GraphNode<{
	asset:AssetPointer<any>;
}>;


export const updateNodeReferences = async(node:GraphNode<any>) => {
	if(node.type === "Form"){
		updateFormNode(node);
	}
	if(node.type === "Scene"){
		updateSceneNode(node);
	}
	if(node.type === "CognitiveTest"){
		updateCognitiveTest(node);
	}
	if(node.type === "Gallery"){
		updateGalleryNode(node);
	}
};


const updateSceneNode = async (node:SceneNode) => {
	await Promise.all(node.parameters.points.map(p => {
		return new Promise<void>(async (resolve, reject) => {
			if(!p.form){
				return resolve();
			}
			const formRef = (p.form as AssetPointer<Form>).ref;

			if(!formRef){
				return resolve();
			}
			const v = await AssetAPI.getAssetVersion(formRef.asset, "latest", "+data");
			p.form = {
				ref:{
					asset:formRef.asset,
					version:v._id
				},
				data:v.data
			}
			resolve();
		});

	}));
};

const updateFormNode = async(node:FormNode) => {
	if(!node.parameters.asset || !node.parameters.asset.ref) { return };
	const asset = node.parameters.asset.ref.asset;
	const v = await AssetAPI.getAssetVersion(asset, "latest", "+data");
	node.parameters.asset = {
		ref:{
			asset,
			version:v._id
		},
		data:v.data
	};
};

const updateCognitiveTest = async(node:CognitiveTestNode) => {
	if(!node.parameters.asset || !node.parameters.asset.ref) { return };
	const asset = node.parameters.asset.ref.asset;
	const v = await AssetAPI.getAssetVersion(asset, "latest", "+data");
	node.parameters.asset = {
		ref:{
			asset,
			version:v._id
		},
		data:v.data
	};
};


const updateGalleryNode = async(node:GalleryNode) => {
	if(!node.parameters.asset || !node.parameters.asset.ref) { return };
	const asset = node.parameters.asset.ref.asset;
	const v = await AssetAPI.getAssetVersion(asset, "latest", "+data");
	node.parameters.asset = {
		ref:{
			asset,
			version:v._id
		},
		data:v.data
	};
};